export const ROAD_MAP_TARGET_DURATION_OPTIONS = [6, 9, 12, 18, 24, 36];

export function getRoadMapPeriodOptions(targetDurationMonths) {
    const duration = Number(targetDurationMonths);
    if (!Number.isFinite(duration) || duration <= 0) return [];

    const options = [];
    for (let period = 1; period <= duration; period += 1) {
        if (duration % period === 0) {
            options.push(period);
        }
    }
    return options;
}

export function resolveRoadMapTargetDurationOptions(currentValue) {
    const current = Number(currentValue);
    const options = [...ROAD_MAP_TARGET_DURATION_OPTIONS];
    if (Number.isFinite(current) && current > 0 && !options.includes(current)) {
        options.push(current);
        options.sort((a, b) => a - b);
    }
    return options;
}

export function resolveRoadMapPeriodValue(targetDurationMonths, currentPeriodMonths, preferred = 3) {
    const options = getRoadMapPeriodOptions(targetDurationMonths);
    if (!options.length) return preferred;

    const current = Number(currentPeriodMonths);
    if (options.includes(current)) return current;
    if (options.includes(preferred)) return preferred;

    return options.find((period) => period >= preferred) ?? options[0];
}

export function buildRoadMapGoalSlots(targetDurationMonths, periodMonths) {
    const duration = Number(targetDurationMonths);
    const period = Number(periodMonths);

    if (!Number.isFinite(duration) || !Number.isFinite(period) || duration <= 0 || period <= 0) {
        return [];
    }

    if (duration % period !== 0) {
        return [];
    }

    const count = duration / period;
    return Array.from({ length: count }, (_, index) => ({
        index: index + 1,
        periodEndMonth: period * (index + 1),
    }));
}

export function isValidRoadMapDurationPeriod(targetDurationMonths, periodMonths) {
    const duration = Number(targetDurationMonths);
    const period = Number(periodMonths);
    return Number.isFinite(duration)
        && Number.isFinite(period)
        && duration > 0
        && period > 0
        && duration % period === 0;
}

export function mergeRoadMapGoals(existingGoals, slots) {
    const descriptionByIndex = new Map(
        (existingGoals || []).map((goal) => [goal.index, goal.description || '']),
    );

    return slots.map((slot) => ({
        index: slot.index,
        periodEndMonth: slot.periodEndMonth,
        description: descriptionByIndex.get(slot.index) || '',
    }));
}

export function formatRoadMapGoalsSummary(goals) {
    if (!goals?.length) return '';

    return goals
        .map((goal) => `No.${goal.index} - ${goal.periodEndMonth}. Ay: ${goal.description || ''}`)
        .join(' | ');
}
